import type { HomePageActions, HomePageData } from "./types";

export const fetchHomePageData = (): HomePageActions => ({
  type: "REQUEST_HOME_PAGE_DATA",
});

export const fetchHomePageDataSuccess = (
  payload: HomePageData
): HomePageActions => ({
  type: "REQUEST_HOME_PAGE_DATA_SUCCESS",
  payload,
});

export const fetchHomePageDataFailed = (): HomePageActions => ({
  type: "REQUEST_HOME_PAGE_DATA_FAILED",
});
